﻿import {isNullOrEmpty} from "@2d-front-monorepo/core";
import {PermitId, Permits, VehicleId, Vehicles} from "@2d-front-monorepo/permits-business";

import {JSX} from "react";
import {useSearchParams} from "react-router";
import Registrations from "../../customers/Registrations";
import {usePermits} from "../../hooks/usePermits";

export default function CreateVehicle(): JSX.Element {
	const [searchParams] = useSearchParams();
	const {permits, holderData} = usePermits();

	const permitId = searchParams.get("permitId") as PermitId;
	const vehicleId = searchParams.get("vehicleId") as VehicleId;

	const permit = isNullOrEmpty(permitId) ? undefined : Permits.find(permits, permitId);
	const vehicle = isNullOrEmpty(vehicleId) ? undefined : Vehicles.get(permits, vehicleId);

	const EditComponent = Registrations.getCreateVehicle();
	return <EditComponent holderData={holderData} permits={permits} permit={permit} vehicle={vehicle}/>;
}
